import {Track, TrackTraceStatus} from '../../types/packingSlipStatusResponse';
import {DeliveredAt, TrackTrace, TransitState} from '../../models/trackTrace';

const isDelivered = (status: TrackTraceStatus): boolean => {
    return [
        TrackTraceStatus.DELIVERED,
        TrackTraceStatus.DELIVERED_AT_NEIGHBOURS,
        TrackTraceStatus.PICKUP_POINT,
        TrackTraceStatus.AT_PICKUP_POINT,
        TrackTraceStatus.COLLECTED_AT_PICKUP_POINT,
    ].includes(status);
};

const getDeliveredAt = (status: TrackTraceStatus): DeliveredAt | null => {
    switch (status) {
        case TrackTraceStatus.DELIVERED_AT_NEIGHBOURS:
            return DeliveredAt.NEIGHBOURS;
        case TrackTraceStatus.PICKUP_POINT:
        case TrackTraceStatus.AT_PICKUP_POINT:
        case TrackTraceStatus.COLLECTED_AT_PICKUP_POINT:
            return DeliveredAt.AT_PICKUP_POINT;
        case TrackTraceStatus.DELIVERED:
            return DeliveredAt.HOME;
        default:
            return null;
    }
};

const isInTransit = (status: TrackTraceStatus): boolean => {
    return [
        TrackTraceStatus.PACKED,
        TrackTraceStatus.SHIPPED,
        TrackTraceStatus.IN_TRANSIT,
        TrackTraceStatus.ATTEMPT_DELAYED,
        TrackTraceStatus.ATTEMPT_NOT_AT_HOME,
    ].includes(status);
};

const getTransitState = (status: TrackTraceStatus): TransitState | null => {
    switch (status) {
        case TrackTraceStatus.IN_SORTING:
        case TrackTraceStatus.PACKED:
        case TrackTraceStatus.SHIPPED:
            return TransitState.SORTING;
        case TrackTraceStatus.IN_TRANSIT:
            return TransitState.OUT_FOR_DELIVERY;
        case TrackTraceStatus.ATTEMPT_DELAYED:
            return TransitState.DELAYED;
        case TrackTraceStatus.ATTEMPT_NOT_AT_HOME:
            return TransitState.NOT_AT_HOME;
        default:
            return null;
    }
};

const isFaulty = (status: TrackTraceStatus): boolean => {
    return [
        TrackTraceStatus.DAMAGED,
        TrackTraceStatus.REFUSED,
        TrackTraceStatus.RETURNED,
        TrackTraceStatus.FAILED,
        TrackTraceStatus.ERROR,
        TrackTraceStatus.OTHER,
    ].includes(status);
};

const convertTrackToTrackTrace = (track: Track): TrackTrace => {
    return {
        id: track.id,
        status: track.status,
        carrier: 'postnl',
        trackTraceCode: track.trackTraceCode,
        trackTraceUrl: track.trackTraceUrl,
        isInTransit: isInTransit(track.status),
        transitState: getTransitState(track.status),
        isDelivered: isDelivered(track.status),
        deliveredAt: getDeliveredAt(track.status),
        isFaulty: isFaulty(track.status),
    };
};

export default convertTrackToTrackTrace;
